(function () {
  var searchTimer;

  var initCategoryFaq = function () {
    $(".category-faq").each(function () {
      var $faq = $(this);

      if ($faq.hasClass("category-faq--init")) return;
      $faq.addClass("category-faq--init");

      var $tabs         = $faq.find(".category-faq__tab");
      var $select       = $faq.find(".category-faq__select");
      var $search       = $faq.find(".category-faq__search");
      var $resultsCount = $faq.find(".category-faq__results-count");
      var $items        = $faq.find(".collapsible-content__item");
      var currentFilter = "all";

      // ── Tab click ──────────────────────────────────────────
      $tabs.on("click", function () {
        var filter = $(this).data("filter");
        currentFilter = filter;
        // Clear search whenever switching tabs
        $search.val("");
        $faq.removeClass("category-faq--no-results");
        $resultsCount.text("");
        applyFilter(filter);
        syncSelect(filter);
        setActiveTab($(this));
      });

      // ── Dropdown change ────────────────────────────────────
      $select.on("change", function () {
        var filter = $(this).val();
        currentFilter = filter;
        $search.val("");
        $faq.removeClass("category-faq--no-results");
        $resultsCount.text("");
        applyFilter(filter);
        syncActiveTab(filter);
      });

      // ── Search input ───────────────────────────────────────
      $search.on("input", function () {
        clearTimeout(searchTimer);
        var query = $(this).val();
        searchTimer = setTimeout(function () {
          applySearch(query.trim());
        }, 200);
      });

      // ── Filter by category (show/hide items) ───────────────
      function applyFilter(filter) {
        if (filter === "all") {
          $items.removeAttr("hidden");
        } else {
          $items.each(function () {
            if ($(this).data("category") === filter) {
              $(this).removeAttr("hidden");
            } else {
              $(this).attr("hidden", "hidden");
            }
          });
        }
      }

      // ── Search ─────────────────────────────────────────────
      function applySearch(query) {
        if (!query) {
          $faq.removeClass("category-faq--no-results");
          $resultsCount.text("");
          applyFilter(currentFilter);
          return;
        }

        var lowerQuery = query.toLowerCase();
        var matchCount = 0;

        $items.each(function () {
          var question = String($(this).data("question") || "").toLowerCase();
          var answer   = String($(this).data("answer")   || "").toLowerCase();

          if (question.indexOf(lowerQuery) !== -1 || answer.indexOf(lowerQuery) !== -1) {
            $(this).removeAttr("hidden");
            matchCount++;
          } else {
            $(this).attr("hidden", "hidden");
          }
        });

        if (matchCount === 0) {
          $faq.addClass("category-faq--no-results");
          $resultsCount.text("");
        } else {
          $faq.removeClass("category-faq--no-results");
          $resultsCount.text(
            matchCount + (matchCount === 1 ? " result" : " results") +
            " for \u201C" + query + "\u201D"
          );
        }
      }

      // ── Sync helpers ───────────────────────────────────────
      function setActiveTab($tab) {
        $tabs.removeClass("is-active").attr("aria-selected", "false");
        $tab.addClass("is-active").attr("aria-selected", "true");
      }

      function syncActiveTab(filter) {
        $tabs.each(function () {
          if ($(this).data("filter") === filter) {
            setActiveTab($(this));
          }
        });
      }

      function syncSelect(filter) {
        $select.val(filter);
      }
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    initCategoryFaq();
    document.addEventListener("shopify:section:load", function () {
      // Re-init new instances only; existing ones are guarded by the --init class
      initCategoryFaq();
    });
  });
})();
